// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__23Hyy","emails":"CreateEditClinics_emails__15xcw","emailTagLabel":"CreateEditClinics_emailTagLabel__3Hh-8"};